import type { Step } from "@xinghai/ui";

/**
 * docs/UX.md §1.1 — 首次使用 = 一条 4 步引导：
 * 注册 → 授权 → 环境检测 → 试录一条。
 */
export const ONBOARDING_STEPS = ["register", "consent", "mic", "warmup"] as const;
export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

const LABELS: Record<OnboardingStep, string> = {
  register: "1 注册",
  consent: "2 授权",
  mic: "3 环境检测",
  warmup: "4 试录",
};

/** Steps for the `<Stepper>` at the top of each onboarding screen. */
export function onboardingSteps(current: OnboardingStep): Step[] {
  const idx = ONBOARDING_STEPS.indexOf(current);
  return ONBOARDING_STEPS.map((id, i) => ({
    id,
    label: LABELS[id],
    done: i < idx,
    locked: i > idx,
  }));
}

export function onboardingIndex(current: OnboardingStep): number {
  return ONBOARDING_STEPS.indexOf(current);
}

const KEY = "xz.onboarded";

/**
 * Brand-new students only. A finished trial on this device, or `warmup_required:
 * false` from the server (already has takes, or finished 试录 before), skips it.
 * `undefined` keeps the old local-only gate so fixtures that omit the field
 * still send a first visit through 试录.
 */
export function needsWarmup(warmupRequired: boolean | undefined): boolean {
  if (isOnboarded()) return false;
  if (warmupRequired === false) return false;
  return true;
}

/** True once the student has finished 试录一条. */
export function isOnboarded(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markOnboarded(): void {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Test helper / 「重新看一遍引导」. */
export function clearOnboarded(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
